const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async getDataAll({ commit }, payload) {
    try {
      let url;
      if (!payload.classSectionId) {
        url = `/api/discussion/classroom/${payload.classroomId}/course/${payload.courseId}?search=${payload.search}`;
      } else {
        url = `/api/discussion/class-section/${payload.classSectionId}?search=${payload.search}`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/discussion/${payload}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetailView({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/discussion/${payload}/view`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  save({ commit }, payload) {
    let url;
    if (!payload.classSectionId) {
      url = `/api/discussion/classroom/${payload.classroomId}/course/${payload.courseId}`;
    } else {
      url = `/api/discussion/class-section/${payload.classSectionId}`;
    }
    return window.axios.post(`${url}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  update({ commit }, payload) {
    return window.axios.put(`/api/discussion/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/discussion/${payload}`);
  },
  // eslint-disable-next-line no-unused-vars
  postComment({ commit }, payload) {
    return window.axios.put(`/api/discussion/${payload.id}/post-comment`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateComment({ commit }, payload) {
    return window.axios.put(`/api/discussion/${payload.id}/update-comment/${payload.parentId}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  deleteComment({ commit }, payload) {
    return window.axios.put(`/api/discussion/${payload.id}/delete-comment/${payload.parentId}`);
  },
  // eslint-disable-next-line no-unused-vars
  hideComment({ commit }, payload) {
    return window.axios.put(`/api/discussion/${payload.id}/hide-comments/${payload.parentId}`, {
      childCommentHidden: payload.childCommentHidden === true ? false : true
    });
  }
};

export default { namespaced, state, getters, mutations, actions };
